import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { GET_ALERT_TOPAY_INVOICE_REPORT } from "../Schema/Report";

const useGetAlertToPayInvoiceReport = ({ fromDate, toDate }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_ALERT_TOPAY_INVOICE_REPORT, {
    variables: {
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
      toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    },
    onCompleted: ({ getAlertToPayInvoiceReport }) => {
      setTableData(getAlertToPayInvoiceReport || []);
      setLoading(false);
    },
    onError: ({ message }) => {
      console.log("Error::", message);
    },
  });

  useEffect(() => {
    refetch();
  }, [fromDate, toDate]);

  return { tableData, loading };
};

export default useGetAlertToPayInvoiceReport;
